export default {
  footerQuickLinks: "快速链接",
  footerAboutRLS: "关于RLS",
  footerOurJourney: "我们的历程",
  footerLeadershipTeam: "领导团队",
  footerContactUs: "联系我们",
  footerConnectWithUs: "与我们联系",
  footerAllRightsReserved: "2025 Refex Life Sciences. 保留所有权利。",
  footerPrivacyPolicy: "隐私政策",
  footerTermsOfService: "服务条款",
};

